import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Poops(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }


return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Oops Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python oops tutorial for beginners.Inside Python object oriented Programming Concepts we use object, class,data encapsulation,data abstraction,inheritance,polymorphism." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python object oriented Programming ,Python oops,Python oops Concept,Python oops Concepts,Python oops Tutorial,Python oops Examplespython oops-1600v-19sd,python oops concepts,Oops concepts in python,Oops in python-1600v,python oops interview questions,python oops Principles,python oops tutorial,python oops Examples" />
<link rel="canonical" href="https://www.codeexampler.com/python-oops" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">python oops concept or Python object-oriented Programming</h1>

    <div className="first">
        <a href="/python-list-method">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-object-and-class">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <p className="mt-4 para">Inside Python object-oriented Programming Concepts, we use Object, class, data encapsulation, data abstraction, inheritance, polymorphism.<br/>
    Python oops Concepts Is a programming methodology, paradigm, or style.<br/>
</p>
<h2 className="mt-4 mh2">There are 6 main Python oops concepts:
</h2>
<h3 className="mt-4 mh3">1, Class<br/>
2, Object and method<br/>
3, Inheritance<br/>
4, Abstraction<br/>
5, Polymorphism<br/>
6, Encapsulation<br/>
</h3>
  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-list-method">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-object-and-class">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
</div>
    </div>
)

}
export default Poops;